import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-device-shfxy",
  "use": "icon-device-shfxy-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-device-shfxy\"><defs><style type=\"text/css\"></style></defs><path d=\"M0 1024V576h1024v448H0z m896-320H128v192h768v-192z m-256 64v128H448v-128h192z m192 0v128h-128v-128h128zM0 0h1024v448H0V0z m128 320h768V128H128v192z m512-128v128H448V192h192z m192 0v128h-128V192h128z\" p-id=\"3312\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol